/**
 * Shared antd ConfigProvider theme for Slider components.
 *
 * Ensures slider handles are clearly visible at rest on dark backgrounds.
 * antd renders handles via box-shadow (colorBgElevated fill + handleColor ring).
 * On dark themes, these blend in — overriding handleColor makes them always visible.
 */
export const sliderTheme = {
	components: {
		Slider: {
			handleSize: 10,
			handleSizeHover: 12,
			handleLineWidth: 2,
			handleLineWidthHover: 2,
			handleColor: 'var(--ant-color-primary)',
			railBg: 'var(--ant-color-fill-tertiary)',
			railHoverBg: 'var(--ant-color-fill-tertiary)',
			trackBg: 'var(--ant-color-primary)',
			trackHoverBg: 'var(--ant-color-primary)',
		},
	},
};
